module.exports = "/assets/data/ff26fbc3ab478c3fc70c62104e381497-AB39.data.json";